import { api } from '@services';

const deleteContact = async (id: string): Promise<void> => {
  await api.delete<void>(`/contacts/${id}`);
};

export { deleteContact };
